import React from 'react';
import Signin from '../login/loginPage';
import NewLoginPage from '../login/newLoginPage';
function LoginPage({ SSOLogin }) {
  return <NewLoginPage SSOLogin={SSOLogin}  />;
}

export default LoginPage;
